import WebMercatorViewport from "viewport-mercator-project";
export const getMinMaxBoundCoordinates = (markers) => {
    const validMarkers = markers === null || markers === void 0 ? void 0 : markers.filter((marker) => marker.latitude && marker.longitude);
    if (!(validMarkers === null || validMarkers === void 0 ? void 0 : validMarkers.length)) {
        return null;
    }
    const minMaxCoordinates = validMarkers.reduce((map, marker) => ({
        minLat: map.minLat > marker.latitude ? marker.latitude : map.minLat,
        maxLat: map.maxLat < marker.latitude ? marker.latitude : map.maxLat,
        minLng: map.minLng > marker.longitude ? marker.longitude : map.minLng,
        maxLng: map.maxLng < marker.longitude ? marker.longitude : map.maxLng,
    }), {
        minLat: validMarkers[0].latitude,
        maxLat: validMarkers[0].latitude,
        minLng: validMarkers[0].longitude,
        maxLng: validMarkers[0].longitude,
    });
    return [
        [minMaxCoordinates.minLng, minMaxCoordinates.maxLat],
        [minMaxCoordinates.maxLng, minMaxCoordinates.minLat],
    ];
};
export const getBound = (markers, options) => {
    if (!markers.length) {
        return undefined;
    }
    const { padding = 20, offset = [0, -40], viewportSize } = options || {};
    const viewport = new WebMercatorViewport({
        width: viewportSize.width,
        height: viewportSize.height,
    });
    const minMaxBoundCoordinates = getMinMaxBoundCoordinates(markers);
    if (!minMaxBoundCoordinates) {
        return undefined;
    }
    const bound = viewport.fitBounds(minMaxBoundCoordinates, {
        padding,
        offset,
    });
    return bound;
};
